<div>
  @if (isLoadingAvailablePlans()) {
    @for (item of [1, 2, 3, 4]; track item) {
      <ion-skeleton-text
        animated
        class="plan box-content !p-0 h-24"
        [class.mt-2]="$index !== 0"
      ></ion-skeleton-text>
    }
  } @else {
    @if (selectedPlan()) {
      <div class="flex flex-col gap-2 mt-2">
        <!-- icon -->
        <img
          class="object-contain h-[26px] self-start"
          [src]="selectedPlan()?.icon ?? '' | cdn"
        />

        <!-- tagline -->
        <ion-text class="text-xs">{{ selectedPlan()?.tagline }}</ion-text>

        <!-- features -->
        @if ((selectedPlan()?.planIncludesV2?.length ?? 0) > 0) {
          @for (plan of selectedPlan()?.planIncludesV2; track $index) {
            <div class="">
              <div>
                <p class="text-xs font-medium mb-0.5">{{ plan.title }}</p>
              </div>
              @for (item of plan.content; track $index) {
                <div class="flex items-center mt-1 gap-1.5 text-[#757575]">
                  <div class="flex items-center">
                    <ion-icon
                      [name]="
                        plan.code === 'ASA_X_AI_NOT_INCLUDED'
                          ? 'ellipse'
                          : 'checkmark-circle'
                      "
                      [style.color]="
                        plan.code === 'ASA_X_AI_NOT_INCLUDED'
                          ? '#C2C2C2'
                          : '#34393d'
                      "
                    ></ion-icon>
                  </div>
                  <div
                    class="flex flex-col text-xs font-normal"
                    [style.color]="
                      plan.code === 'ASA_X_AI_NOT_INCLUDED'
                        ? '#C2C2C2'
                        : '#757575'
                    "
                  >
                    <ion-text> {{ item.label }} </ion-text>
                    <ion-text class="text-[10px] italic">
                      {{ item.detail }}
                    </ion-text>
                  </div>
                </div>
              }
            </div>
          }
        }

        <!-- total service value -->
        <ion-text class="text-xs">
          Total service value:
          {{ price() | currency: 'IDR' }}
        </ion-text>

        <!-- discount display -->
        @if (isDiscount()) {
          <div class="flex items-center text-xs gap-1.5">
            <ion-text>Price</ion-text>
            <span class="line-through">{{
              dailyPrice() | currency: 'IDR'
            }}</span>
            <div
              class="text-caption font-medium uppercase discount py-[3px] px-[12px] rounded-[100px]"
            >
              {{ discountText() }}
            </div>
          </div>
        }

        <!-- daily price & annual charge -->
        <div class="flex flex-col gap-0.5">
          <ion-text class="text-xl font-bold">
            {{ totalDailyPrice() | currency: 'IDR' }}/Day
          </ion-text>
          <ion-text class="text-[10px]">
            Charged Annually at {{ totalPrice() | currency: 'IDR' }}
          </ion-text>
        </div>
      </div>
    }
  }
</div>
